import { organizationsApi } from "api";
import { useCallback, useContext, useEffect } from "react";
import {
  Organization,
} from "model/organizationModel";
import { OrganizationsContext } from "contexts";
import useUser from "./useUser";

const useOrganizations = (
  sleep?: number,
): [Organization[], () => Promise<void>] => {
  const {
    state: { organizationsFirstSearch, organizations },
    actions: { addOrganizationsFirstSearch, setOrganizations },
  } = useContext(OrganizationsContext);
  const user = useUser();

  const getOrganizations = useCallback(async () => {
    try {
      if (user) {
        const { data } = await organizationsApi.get<{
          organizations: Organization[];
        }>(`user`);
        setOrganizations(data.organizations);
      } else {
        setOrganizations([]);
      }
    } catch {
    } finally {
    }
    // dispatch(addSelectedOrganization({ id: data.owning[0]?.id || data.participating[0]?.id }));
  }, [setOrganizations, user]);

  useEffect(() => {
    const start = () => {
      if (!organizationsFirstSearch) {
        addOrganizationsFirstSearch({});
        getOrganizations();
      }
    };
    if (sleep) {
      setTimeout(start, sleep);
    } else {
      start();
    }
  }, [
    sleep,
    getOrganizations,
    organizationsFirstSearch,
    addOrganizationsFirstSearch,
  ]);

  return [organizations, getOrganizations];
};

export default useOrganizations;
